import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import { DcpProductPicker } from './DcpProductPicker';

export const DcpProductPickerFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DcpProductPicker',
    component: DcpProductPicker,
  }),
);
